import { gql } from 'urql';

export const PURCHASE_ITEM_FIELDS = gql`
  fragment PurchaseItemFields on PurchaseItem {
    id
    codigo
    descripcion
    cantidad
    precio
    alicuotaIva
    subtotal
  }
`;

export const ATTACHMENT_FIELDS = gql`
  fragment AttachmentFields on Attachment {
    id
    filename
    url
    mimeType
    size
  }
`;

export const PURCHASE_FIELDS = gql`
  ${PURCHASE_ITEM_FIELDS}
  ${ATTACHMENT_FIELDS}
  fragment PurchaseFields on Purchase {
    id
    supplierId
    supplier {
      id
      razon_social
      cuit
      condicion_iva
    }
    tipo
    puntoVenta
    numero
    fecha
    cae
    caeVto
    moneda
    condicionCompra
    importes {
      neto
      iva21
      iva105
      iva27
      exento
      noGravado
      percepIva
      percepIibb
      otros
      total
    }
    items {
      ...PurchaseItemFields
    }
    adjuntos {
      ...AttachmentFields
    }
    observaciones
    totalPagado
    saldoPendiente
    estadoPago
    createdAt
    updatedAt
  }
`;

export const Q_PURCHASES = gql`
  ${PURCHASE_FIELDS}
  query Purchases($filter: PurchaseFilterInput, $pagination: PaginationInput) {
    purchases(filter: $filter, pagination: $pagination) {
      items {
        ...PurchaseFields
      }
      pageInfo {
        totalItems
        totalPages
        page
        perPage
      }
    }
  }
`;

export const Q_PURCHASE = gql`
  ${PURCHASE_FIELDS}
  query Purchase($id: ID!) {
    purchase(id: $id) {
      ...PurchaseFields
    }
  }
`;

export const M_CREATE_PURCHASE = gql`
  ${PURCHASE_FIELDS}
  mutation CreatePurchase($input: PurchaseInput!) {
    createPurchase(input: $input) {
      ...PurchaseFields
    }
  }
`;

export const M_UPDATE_PURCHASE = gql`
  ${PURCHASE_FIELDS}
  mutation UpdatePurchase($id: ID!, $input: PurchaseInput!) {
    updatePurchase(id: $id, input: $input) {
      ...PurchaseFields
    }
  }
`;

export const M_ATTACH_PURCHASE_FILES = gql`
  ${PURCHASE_FIELDS}
  mutation AttachPurchaseFiles($id: ID!, $files: [AttachmentInput!]!) {
    attachPurchaseFiles(id: $id, filesMeta: $files) {
      ...PurchaseFields
    }
  }
`;

export const M_DELETE_PURCHASE = gql`
  mutation DeletePurchase($id: ID!) {
    deletePurchase(id: $id) {
      success
    }
  }
`;
